// extracted by mini-css-extract-plugin
export default {"root":"SelectSolutionTypeModal_root__u8+YT","container":"SelectSolutionTypeModal_container__i-yWy","cards":"SelectSolutionTypeModal_cards__7FtlG"};